import { BaseApi } from "../base";

export default class ClientSsoApi extends BaseApi {
  protected readonly service = "global-accounts";
  protected readonly prefix = "clients";
  protected readonly version = 2;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteConsent = (clientId: string, coverage = "organization") => this.delete(`${clientId}/consent`, { coverage });
}
